import { Error } from '@/components/error';

const ErrorNotFound = () => <Error variant='not-found' />;

export { ErrorNotFound };
